webpackJsonp([8],{

/***/ "08eu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"page"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3eBu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "73wk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("hNT/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("rQBB");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'main',
	data: function data() {
		return {
			active: 'install',
			type: ''
		};
	},
	created: function created() {
		console.log(this.$route.path);
		if (this.$route.path != '/f') {
			this.$router.push({
				path: 'home',
				query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({ type: 'cc' }, 'type', window.location.hash.split('type=')[1])
			});
		}
	},

	methods: {
		handleMenu: function handleMenu(name) {
			this.$router.push({
				path: 'home',
				query: { cate: name, type: window.location.hash.split('type=')[1] }
			});
		}
	}
});

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "7wDq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D6U/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            spanLeft: 5,
            spanRight: 19,
            type: 't8s',
            active: 'list'
        };
    },

    computed: {
        iconSize: function iconSize() {
            return this.spanLeft === 5 ? 14 : 24;
        }
    },
    created: function created() {
        console.log(this.$route.path);
        if (this.$route.path == '/admin') {
            var type = this.$route.query.type ? this.$route.query.type : 'cc';
            this.$router.push({
                path: '/admin/list?type=' + type
            });
        }
        this.active = this.$route.path.replace('/admin/', '');
        this.type = window.location.hash.split('type=')[1];
    },

    methods: {
        toggleClick: function toggleClick() {
            if (this.spanLeft === 5) {
                this.spanLeft = 2;
                this.spanRight = 22;
            } else {
                this.spanLeft = 5;
                this.spanRight = 19;
            }
        },
        handleMenu: function handleMenu(name) {
            console.log(name);
            this.$router.push({
                path: '/admin/' + name,
                query: { type: this.type }
            });
        }
    }
});

/***/ }),

/***/ "JB2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout admin",class:{'layout-hide-text': _vm.spanLeft < 5}},[_c('Row',{attrs:{"type":"flex"}},[_c('Col',{staticClass:"layout-menu-left",attrs:{"span":_vm.spanLeft}},[_c('Menu',{attrs:{"active-name":_vm.active,"theme":"light","width":"auto"},on:{"on-select":_vm.handleMenu}},[_c('div',{staticClass:"layout-logo-left"},[_c('img',{attrs:{"src":__webpack_require__("7Otq"),"alt":""}})]),_vm._v(" "),_c('MenuItem',{attrs:{"name":"list"}},[_c('Icon',{attrs:{"type":"home","size":14}}),_vm._v(" "),_c('span',{staticClass:"layout-text"},[_vm._v("常见问题")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"name":"feed"}},[_c('Icon',{attrs:{"type":"arrow-swap","size":14}}),_vm._v(" "),_c('span',{staticClass:"layout-text"},[_vm._v("用户提问")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"name":"report"}},[_c('Icon',{attrs:{"type":"arrow-swap","size":14}}),_vm._v(" "),_c('span',{staticClass:"layout-text"},[_vm._v("统计")])],1)],1)],1),_vm._v(" "),_c('Col',{staticClass:"layout-menu-right",attrs:{"span":_vm.spanRight}},[_c('div',{staticClass:"layout-header"},[_c('Button',{attrs:{"type":"text"},on:{"click":_vm.toggleClick}},[_c('Icon',{attrs:{"type":"navicon","size":"32"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"layout-content"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"layout-copy"},[_vm._v("\n                    2018 © Teyes\n                ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JfuS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("cUXF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_59c95520_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("hb9i");
var normalizeComponent = __webpack_require__("Cut0")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_59c95520_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("b7XN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview__ = __webpack_require__("28RE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__("byqf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css__ = __webpack_require__("r3fZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__("rQBB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_froala_wysiwyg__ = __webpack_require__("PcsB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_froala_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_froala_wysiwyg__);








__webpack_require__("5WoQ");
__webpack_require__("3eBu");
__webpack_require__("XkXl");
__webpack_require__("jGHE");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_froala_wysiwyg___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_iview___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);

// 路由配置
var RouterConfig = {
    routes: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* routers */]
};

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */](RouterConfig);

router.beforeEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_3_iview___default.a.LoadingBar.start();
    __WEBPACK_IMPORTED_MODULE_6__util__["a" /* default */].title(to.meta.title);
    // Util.toDefaultPage([ ...appRouter], to.name, router, next);
    next();
    __WEBPACK_IMPORTED_MODULE_3_iview___default.a.LoadingBar.finish();
});

router.afterEach(function () {
    __WEBPACK_IMPORTED_MODULE_3_iview___default.a.LoadingBar.finish();
    window.scrollTo(0, 0);
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: router,
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
    }
});

/***/ }),

/***/ "XkXl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export appRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Main__ = __webpack_require__("s6+2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Admin__ = __webpack_require__("qbhH");



var appRouter = [{
    path: '/',
    title: '首页',
    name: 'main',
    component: __WEBPACK_IMPORTED_MODULE_0__components_Main__["a" /* default */],
    children: [{ path: 'home', title: '安装', name: 'home', component: function component(resolve) {
            __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("StSv")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        } }, { path: 'f', title: '反馈', name: 'f', component: function component(resolve) {
            __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fqoJ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        } }]
}, {
    path: '/admin',
    title: '管理端',
    name: 'admin',
    component: __WEBPACK_IMPORTED_MODULE_1__components_Admin__["a" /* default */],
    children: [{ path: 'list', title: '常见问题', name: 'list', component: function component(resolve) {
            __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hUJY")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        } }, { path: 'listInfo', title: '编辑', name: 'listInfo', component: function component(resolve) {
            __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QIJ5")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        } }, { path: 'feed', title: '用户提问', name: 'feed', component: function component(resolve) {
            __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LaG1")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        } }, { path: 'feedInfo', title: '提问编辑', name: 'feedInfo', component: function component(resolve) {
            __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wITb")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        } }, { path: 'report', title: '统计', name: 'report', component: function component(resolve) {
            __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bVy+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        } }]
}];
var routers = [].concat(appRouter);

/***/ }),

/***/ "cUXF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "hb9i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jGHE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qbhH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_Admin_vue__ = __webpack_require__("D6U/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_762114e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_Admin_vue__ = __webpack_require__("JB2+");
function injectStyle (ssrContext) {
  __webpack_require__("JfuS")
}
var normalizeComponent = __webpack_require__("Cut0")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-762114e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_Admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_762114e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_Admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r3fZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rQBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("C77M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("Yf2v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);


var util = {};
util.title = function (title) {
    title = title || 'Teyes 常见问题';
    window.document.title = title;
};
var ajaxUrl =  false ? 'http://127.0.0.1/teyes_faq/api/index.php' :  true ? 'api/index.php' : 'api/index.php';

var smsurl =  false ? 'http://192.168.1.103/teyes_faq/api/sms/smsService.php' :  true ? 'api/sms/smsService.php' : 'api/sms/smsService.php';

util.ajax = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    timeout: 30000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [function (data) {
        return __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(data);
    }],
    methods: 'post',
    baseURL: ajaxUrl
});

util.server = ajaxUrl;

util.ajaxSms = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    timeout: 30000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [function (data) {
        return __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(data);
    }],
    methods: 'post',
    baseURL: smsurl
});

util.toDefaultPage = function (routers, name, route, next) {
    var len = routers.length;
    var i = 0;
    var notHandle = true;
    while (i < len) {
        if (routers[i].name === name && routers[i].redirect === undefined) {
            route.replace({
                name: routers[i].children[0].name
            });
            notHandle = false;
            next();
            break;
        }
        i++;
    }
    if (notHandle) {
        next();
    }
};

/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),

/***/ "s6+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("73wk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_243bc551_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("08eu");
function injectStyle (ssrContext) {
  __webpack_require__("7wDq")
}
var normalizeComponent = __webpack_require__("Cut0")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_243bc551_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4ad536d7ff63fc583858.js